import { Component, OnInit } from "@angular/core";
import { MessageService } from "primeng/api";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import {
  QualityGateFilter,
  QualityGateMultiSubmission,
  QualityGateSubmission,
  TransactionTypeOtherEntry,
} from "src/api/models";
import { QualityGateService } from "src/api/services";
import { preventLeadingSpaceKey } from "src/core/utils/input-validation.utils";

@Component({
  selector: "app-type-other-unprocessed",
  // imports: [],
  templateUrl: "./unprocessed.component.html",
  styleUrl: "./unprocessed.component.css",
  standalone: false,
})
export class TypeOtherUnprocessedComponent implements OnInit {
  ref!: DynamicDialogRef;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  unprocessedTransactions: TransactionTypeOtherEntry[] = [];
  selectedTransaction: any[] = [];
  first = 0;
  rows = 10;
  isLoading: boolean = false;
  issuerName?: string;
  filingId?: number;
  insiderName?: string;
  constructor(
    private _qualityGateService: QualityGateService,
    public dialogService: DialogService,
    private _messageService: MessageService
  ) {}

  ngOnInit(): void {}
  getUnprocessedTransactions() {
    const params: QualityGateFilter = {
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      processStatus: "UNPROCESSED",
      qualityGateType: "Other_Transaction_Type",
      issuerName: this.issuerName,
      insiderName: this.insiderName,
      filingId: this.filingId,
    };
    this.isLoading = true;
    this._qualityGateService.view(params).subscribe({
      next: (value) => {
        this.unprocessedTransactions = value.transactionTypeOtherEntries ?? [];
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.unprocessedTransactions?.[0]?.totalCount ?? 0;
        this.isLoading = false;
      },
    });
  }

  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getUnprocessedTransactions();
  }
  onExcludeClick(share: TransactionTypeOtherEntry) {
    const submission: QualityGateSubmission = {
      qualityGateType: "Other_Transaction_Type",
      missingSharesSubmission: {
        entryId: 0,
        indeterminable: false,
      },
      transactionTypeOtherSubmission: {
        entryId: share.entryId ?? 0,
        updatedTransactionType: share.updatedTransactionType || "",
      },
      transactionTypeBuySubmission: {
        entryId: 0,
      },
      missingSecurityBreakDownSubmission: {
        entryId: 0,
      },
      aggregateSharesValidationSubmission: {
        entryId: 0,
        indeterminable: false,
      },
    };

    this._qualityGateService.submit(submission).subscribe({
      next: (response) => {
        this._messageService.add({
          severity: "success",
          summary: "Submission Successful",
          detail: "The record has been excluded successfully.",
        });
        this.getUnprocessedTransactions();
      },
      error: (err) => {
        this._messageService.add({
          severity: "error",
          summary: "Submission Failed",
          detail: err?.error?.message || "An error occurred while submitting.",
        });
      },
    });
  }
  // onSelectionChange(share: TransactionTypeOtherEntry, event: any) {
  //   share.updatedTransactionType = (event.target as HTMLSelectElement).value;
  // }
  onSearch() {
     const fid = String(this.filingId ?? '').trim();
  if (fid && !/^\d+$/.test(fid)) {
    return;
  }
    this.first = 0;
    this.paginator.pageNumber = 1;
    this.getUnprocessedTransactions();
  }
  preventSpaceKey(event: KeyboardEvent): void {
        preventLeadingSpaceKey(event);
      }
    onGroupExclusionClick() {
      const entryIds = this.selectedTransaction
        .filter((share) => share.entryId !== undefined)
        .map((share) => share.entryId);
      const submission: QualityGateMultiSubmission = {
        entryIds: entryIds,
        indeterminable: true,
        qualityGateType: "Other_Transaction_Type",
      };
  
      this._qualityGateService.multiSubmission(submission).subscribe({
        next: (response) => {
          this._messageService.add({
            severity: "success",
            summary: "Submission Successful",
            detail: "The record has been excluded successfully.",
          });
          this.selectedTransaction = [];
          this.getUnprocessedTransactions();
        },
        error: (err) => {
          this._messageService.add({
            severity: "error",
            summary: "Submission Failed",
            detail: err?.error?.message || "An error occurred while submitting.",
          });
        },
      });
    }
}
